import { Component, computed, inject, Signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  IProgressBarStep,
  TicketConfigurationProgressTrackerComponent,
} from '../../../components/feedback/ticket-configuration-progress-tracker/ticket-configuration-progress-tracker.component';
import { SubscriptionFormService } from '../../../services/subscription/subscription-form.service';
import {
  EEntityType,
  ERelationType,
  IMask,
  ISubscriptionConfig,
} from '@web/dtos';
import { SubscriptionConfigStore } from '../../../services/api/subscription/subscription-config-store.service';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ERoute } from '../../../constants/routes.enum';

@Component({
  selector: 'aw-subscription-option-configuration-page',
  imports: [TicketConfigurationProgressTrackerComponent, RouterOutlet],
  templateUrl: './subscription-configuration-page.component.html',
})
export class SubscriptionConfigurationPageComponent {
  private subscriptionFormService: SubscriptionFormService = inject(
    SubscriptionFormService
  );
  private readonly subscriptionConfigStore: SubscriptionConfigStore = inject(
    SubscriptionConfigStore
  );
  private readonly textStore: WebTextStore = inject(WebTextStore);

  private readonly textFilterPipe: FilterTextsPipe = new FilterTextsPipe();
  private readonly languagePipe: LanguagePipe = new LanguagePipe();

  protected readonly ERoute: typeof ERoute = ERoute;
  private readonly subscriptionConfig: string = 'subscription-configuration/';
  private readonly options: string = 'options/';

  protected progressBar: Signal<IProgressBarStep[]> = computed(() =>
    this.subscriptionConfigStore.subscriptionConfig()
      ? this.buildSubscriptionTicketConfigProgressBar()
      : []
  );

  constructor() {
    this.subscriptionFormService.resetForm();
  }

  private buildSubscriptionTicketConfigProgressBar(): IProgressBarStep[] {
    const subscriptionConfig: ISubscriptionConfig | undefined =
      this.subscriptionConfigStore.subscriptionConfig();
    if (!subscriptionConfig) {
      return [];
    }
    const baseMasks: IMask[] = this.subscriptionConfigStore.baseMasks() ?? [];

    if (subscriptionConfig) {
      const baseUrl: string =
        this.subscriptionConfig +
        this.options +
        encodeURIComponent(subscriptionConfig.name) +
        '/mask/';
      const configs = baseMasks.map((mask: IMask, index: number) => ({
        label: mask.name,
        stepIndex: index,
        url: baseUrl + index,
      }));

      return configs.concat({
        stepIndex: configs.length,
        label: this.languagePipe.transform(
          this.textFilterPipe.transform(
            this.textStore.texts(),
            ERelationType.payment,
            EEntityType.subscription
          )
        ),
        url:
          this.subscriptionConfig +
          this.options +
          encodeURIComponent(subscriptionConfig.name) +
          `/${ERoute.payment}`,
      });
    }

    return [];
  }
}
